import React from 'react';
import Seo from './components/Seo';
import JsonLd from './components/JsonLd';
import Header from './components/Header';
import Hero from './components/Hero';
import Logos from './components/Logos';
import Services from './components/Services';
import Solutions from './components/Solutions';
import Process from './components/Process';
import CaseStudies from './components/CaseStudies';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Seo />
      <JsonLd />
      <Header />
      <main>
        <Hero />
        <Logos />
        <Services />
        <Solutions />
        <Process />
        <CaseStudies />
        <Pricing />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
